import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { IdentityState } from '../../common/auth/identity.state';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  constructor(
    private readonly identity: IdentityState,
    private readonly router: Router,
    private readonly auth: AuthService,
  ) {}
  canActivate(
    _: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.identity.load.pipe(
      filter(load => !!load.data || load.erred),
      map(load => {
        if (!load.erred) {
          return true;
        }
        console.error(load.error); // eslint-disable-line no-console
        if (
          load.error instanceof HttpErrorResponse &&
          load.error.status === 401
        ) {
          if (
            (load.error.error || load.error.message) ==
            'User must reset password'
          ) {
            this.auth.deauthenticate();
            this.router.navigate(['login', 'forgot'], {
              queryParams: { reason: 'forced' },
            });
          } else {
            // log in user if authentication is not recognized
            this.auth.deauthenticate();
            this.router.navigate(['login'], {
              queryParams: { next: routerState.url },
            });
          }
        }
        return false;
      }),
    );
  }
}
